import { ref } from "vue";

export const gruposArquivos = ref([])
